var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-textarea',{attrs:{"label":"Citation","placeholder":"Saisissez la citation","auto-grow":""},model:{value:(_vm.obj.text),callback:function ($$v) {_vm.$set(_vm.obj, "text", $$v)},expression:"obj.text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }